import { atom } from 'jotai'
import { INotification, IPagination } from 'kach-clients'
import { IUser } from '../services/authentication.service'

export const notificationsAtom = atom<Partial<IPagination<INotification>>>({})
